import { render, staticRenderFns } from "./Testimonialpopup.vue?vue&type=template&id=5322c27e"
import script from "./Testimonialpopup.vue?vue&type=script&lang=js"
export * from "./Testimonialpopup.vue?vue&type=script&lang=js"
import style0 from "./Testimonialpopup.vue?vue&type=style&index=0&id=5322c27e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports